export function cn(...values) {
    return values.filter(Boolean).join(" ");
}
//# sourceMappingURL=cn.js.map